import React, { useState, useEffect } from "react";
import { Layout, Button, QRCode, Modal, message } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";
import "./detail.scss";
import axiosInstance from "@/axios/axiosInstance";
import { useLocation } from "react-router-dom";
import tool from "@/assets/tool";
import { setupWechatShare, updateMetaTags } from "@/utils/shareConfig";

const DataDetailPage = () => {
  const [dataDetail, setDatali] = useState({});
  const [dataset, setData] = useState([]);
  const [user, setUser] = useState({});
  const [qrVisible, setQrVisible] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const profilePictureUrl = queryParams.get("profilePictureUrl");
  const nickName = queryParams.get("nickName");

  const fetchDetails = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/dataSet/page/detail?dataSetId=${id}`
      );
      const data = response.data.data;
      setDatali(data);

      // 设置分享配置
      setupWechatShare({
        title: data.title,
        desc: data.introduction?.slice(0, 100) || "渐风AI数据集",
      });

      updateMetaTags(
        data.title,
        data.introduction?.slice(0, 200) || "渐风AI数据集"
      );
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  const getOthCom = async () => {
    try {
      const response = await axiosInstance.get(`dataSet/page/list`);
      const datasets = response.data.data?.slice(0, 6) || [];
      setData(datasets);
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    }
  };

  useEffect(() => {
    if (id) {
      setUser({
        nickName: nickName,
        profilePictureUrl: profilePictureUrl,
      });
      fetchDetails(id);
      getOthCom();
    }
  }, [id, nickName, profilePictureUrl]);

  const toDetail = (record) => {
    const params = new URLSearchParams({
      id: record.dataSetId,
      profilePictureUrl: record.profilePictureUrl,
      nickName: record.nickName,
    });
    window.location.href = `/dataset_detail?${params.toString()}`;
  };

  const getLabel = (l) => {
    if (!l) return "";
    const fileTypes = [
      { key: "1", value: "压缩文件" },
      { key: "2", value: "图片文件" },
      { key: "3", value: "音视频文件" },
      { key: "4", value: "应用程序" },
      { key: "5", value: "PDF文档" },
      { key: "6", value: "Word文档" },
      { key: "11", value: "Excel工作表" },
      { key: "22", value: "PPT幻灯片" },
      { key: "33", value: "Flash影片" },
      { key: "44", value: "CHM文件" },
      { key: "55", value: "帮助文件" },
      { key: "66", value: "其他文件" },
    ];
    return fileTypes.find((v) => v.key === l)?.value || "";
  };

  const handleShare = () => {
    setQrVisible(true);
  };

  const copyLink = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => {
        message.success("链接已复制到剪贴板");
      })
      .catch(() => {
        message.error("复制失败，请手动复制");
      });
  };

  return (
    <Layout className="dataset-detail">
      <div className="detail-header">
        <div className="header-content">
          <h1 className="title">数据集详情</h1>
          <div className="subtitle">
            {dataDetail.title}
            <ShareAltOutlined className="share-icon" onClick={handleShare} />
          </div>
          <div className="meta-info">
            <img
              src={`/file/${dataDetail.profilePictureUrl}`}
              className="user-avatar"
              alt="用户头像"
            />
            <span className="username">
              {user.nickName || tool.hideMiddleFour(dataDetail.phone)}
            </span>
            <span className="publish-time">于{dataDetail.createTime}发布</span>
          </div>
          <div className="file-info">
            <div className="info-item">
              <span className="label">文件类型：</span>
              <span className="value">{getLabel(dataDetail.fileType)}</span>
            </div>
            <div className="info-item">
              <span className="label">文件大小：</span>
              <span className="value">
                {dataDetail.fileSize}
                {dataDetail.fileUnit}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="detail-content">
        <div className="main-content">
          <section className="intro-section">
            <div className="section-title">数据集介绍</div>
            <div className="intro-content">{dataDetail.introduction}</div>
          </section>

          <section className="price-section">
            <div className="section-title">商品费用</div>
            <div className="price-grid">
              <div className="grid-item">
                <span className="label">付费方式</span>
                <span className="value">现金支付</span>
              </div>
              <div className="grid-item">
                <span className="label">交付方式</span>
                <span className="value">网络下载</span>
              </div>
              <div className="grid-item">
                <span className="label">数量</span>
                <span className="value">1组</span>
              </div>
              <div className="grid-item">
                <span className="label">价格</span>
                <span className="value highlight">￥{dataDetail.price}</span>
              </div>
            </div>
          </section>

          <section className="recommendations">
            <h2>推荐数据集</h2>
            <div className="recommendation-list">
              {dataset.map((item, index) => (
                <div
                  key={item.dataSetId}
                  className="recommendation-item"
                  onClick={() => toDetail(item)}
                >
                  <div className="item-number">{index + 1}</div>
                  <div className="item-content">
                    <div className="item-title">{item.title}</div>
                    <div className="item-size">
                      {item.fileSize}
                      {item.fileUnit}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <aside className="sidebar">
          <div className="user-card">
            <div className="user-info">
              <img
                src={`/file/${user.profilePictureUrl}`}
                className="avatar"
                alt="用户头像"
              />
              <span className="name">
                {user.nickName || tool.hideMiddleFour(dataDetail.phone)}
              </span>
            </div>
            <Button type="primary" disabled>
              关注
            </Button>
          </div>

          <div className="price-card">
            <div className="total-price">￥{dataDetail.price}</div>
            <div className="price-details">
              <div className="detail-item">
                <span>购买单价：</span>
                <span>￥{dataDetail.price}</span>
              </div>
              <div className="detail-item">
                <span>购买数量：</span>
                <span>1组</span>
              </div>
            </div>
          </div>
        </aside>
      </div>

      <div className="disclaimer">
        <section className="disclaimer-section">
          <h3>信息声明</h3>
          <p>
            渐风AI上的所有商品信息等内容，是渐风AI重要的经营资源，未经许可，禁止非法转载使用。
          </p>
          <p>
            注：本站商品信息均来自于发布用户，其真实性、准确性和合法性由信息拥有者（发布用户）负责。本站不提供任何保证，并不承担任何法律责任。
          </p>
        </section>

        <section className="disclaimer-section">
          <h3>价格说明</h3>
          <p>价格：价格为商品的销售价格，是您最终决定是否购买商品的依据。</p>
          <p>
            异常问题：商品的具体售价以订单结算页价格为准，如您发现商品售价或商品信息有异常，建议您购买前先联系发布用户咨询。
          </p>
        </section>
      </div>

      <Modal
        title="分享到微信"
        open={qrVisible}
        onCancel={() => setQrVisible(false)}
        footer={null}
        className="share-modal"
      >
        <div className="share-content">
          <div className="qr-section">
            <QRCode value={window.location.href} size={200} />
            <p>微信扫码分享</p>
          </div>
          <div className="share-options">
            <Button onClick={copyLink}>复制链接</Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default DataDetailPage;
